// Anchor bar script with Waypoint - included through vendor folder
(function (window, document, $) {

    $(document).ready(function () {
        if( $( '.section-navbar-scrollto' ).length ) {
            var sticky = new Waypoint.Sticky({
                element: $( '.section-navbar-scrollto' ),
                offset: $( '.section-navbar-scrollto' ).outerHeight(),
                wrapper: '<div class="section-navbar-scrollto-sticky-wrapper" />',
            })

            var footerAnchorWaypoint = new Waypoint({
                element: $( 'footer' ),
                handler: function(direction) {
                    $( '.section-navbar-scrollto' ).toggleClass( 'stuck' );
                }, 
                offset: function() {
                    return $( '.section-navbar-scrollto' ).outerHeight()
                }
            });

            setAnchorNavStyle();

            $( ".navbar-scrollto-link" ).click(function (e) {
                e.preventDefault();
                $( ".navbar-scrollto-link.current-section" ).removeClass( 'current-section' );
                $( this ).addClass( 'current-section' );
                //get active section id
                var active_section = $( this ).attr( 'href' );

                // only do this if it's an anchor link
                if( active_section.match( "^#" ) ) {
                    $('html, body').animate({
                        //and scroll to the section
                        scrollTop: ( $( active_section ).offset().top - ( $( '.section-navbar-scrollto' ).outerHeight() + 30 ) )
                    }, 500);
                }
            });


            $( document ).scroll( function () {
                //get document scroll position
                var current_position = $( document ).scrollTop();
                var nav_height = $( '.section-navbar-scrollto' ).outerHeight();

                setAnchorNavStyle();
            
                //check active section
                $( '.navbar-scrollto-link' ).each( function( i ) {
                    var section = $( this ).attr( 'href' );

                    if( $( section ).length && section.match( "^#" ) ) {
                        var top    = $( section ).offset().top;
                        var bottom = top + $( section ).outerHeight();

                        if( current_position >= ( top - ( nav_height + 40 ) ) && current_position <= bottom ) {
                            if( !$( this ).hasClass( 'current-section' ) ) {
                                $( ".navbar-scrollto-link.current-section" ).removeClass( 'current-section' );
                                $( this ).addClass( 'current-section' );
                            }
                        }
                    }
                });
            });
        }


        // make the anchor nav smaller if it has multiple rows
        function setAnchorNavStyle() {
            if( $( '.section-navbar-scrollto' ).outerHeight() > 70 ) {
                $( '.section-navbar-scrollto' ).addClass( 'smaller' );
            } else {
                $( '.section-navbar-scrollto' ).removeClass( 'smaller' );
            }
        }
    });

}(window, document, jQuery));
